import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import isFn from 'utils/predicates/function/isFn.util';

const asFunction = (fn) => (isFn(fn) ? fn : alwaysNoop);

asFunction.DEFAULT_FUNCTION = alwaysNoop;

export default asFunction;
